export const onAddDialogDone = project => ({
  widget: 'projects',
  type: 'onAddDialogDone',
  payload: { project },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onAddDialogDone.js